import { Link } from 'foundations-components/transitional/components/Link';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExitSearchAndFilterModeButton = ({
  exitHandler = () => {}
}) => {
  return /*#__PURE__*/_jsx(BackButton, {
    paddingBlock: "400",
    children: /*#__PURE__*/_jsx(Link, {
      onClick: exitHandler,
      "data-test-id": "exit-search-and-filtering-mode-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.exit"
      })
    })
  });
};
ExitSearchAndFilterModeButton.displayName = 'ExitSearchAndFilterModeButton';
export default ExitSearchAndFilterModeButton;